  function initializeCountdown(endDate) {
    const hoursElement = document.querySelector('#hours .timer-value');
    const minutesElement = document.querySelector('#minutes .timer-value');
    const secondsElement = document.querySelector('#seconds .timer-value');

    function updateCountdown() {
      const now = new Date().getTime();
      const timeRemaining = endDate - now;

      if (timeRemaining < 0) {
        hoursElement.innerHTML = "00";
        minutesElement.innerHTML = "00";
        secondsElement.innerHTML = "00";
        clearInterval(interval);
        return;
      }

      const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      hoursElement.innerHTML = hours < 10 ? '0' + hours : hours;
      minutesElement.innerHTML = minutes < 10 ? '0' + minutes : minutes;
      secondsElement.innerHTML = seconds < 10 ? '0' + seconds : seconds;
    }

    const interval = setInterval(updateCountdown, 1000);
    updateCountdown(); // Initial call to display the timer immediately
  }

  // Set the end date for the countdown
  const endDate = new Date('2024-10-30T23:30:00').getTime();
  initializeCountdown(endDate);
